import { render, staticRenderFns } from "./EditableTag.vue?vue&type=template&id=b2d628b8&"
import script from "./EditableTag.vue?vue&type=script&lang=js&"
export * from "./EditableTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports